import { isNativeApp } from "@/lib/runtime";

const ALLOWED_RETURN_SCHEMES = new Set(["lapstr", "lapstr-dev"]);

export function isNativeAuthReturnScheme(value) {
  return ALLOWED_RETURN_SCHEMES.has(value);
}

export function getNativeAuthReturnScheme() {
  if (!isNativeApp()) return null;
  return process.env.REACT_APP_RELEASE_STAGE === "prod" ? "lapstr" : "lapstr-dev";
}

export function isAndroidWebBrowser() {
  if (isNativeApp() || typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

export function buildNativeAuthReturnUrl(result, requestedScheme = "lapstr") {
  const scheme = isNativeAuthReturnScheme(requestedScheme) ? requestedScheme : "lapstr";
  const search = new URLSearchParams({ result });
  return `${scheme}://app/?${search.toString()}`;
}
